export default (id, search = "") => ({
  id: id,
  search: search,
  open: false,
  highlightedIndex: -1,
  initialValue: "",
  activeDescendant: "",
  highlightPrevious() {
    if (this.highlightedIndex > 0) {
      this.highlightedIndex = this.highlightedIndex - 1;
      this.search =
        this.$refs.results.children[this.highlightedIndex].getAttribute(
          "data-result-name"
        );
      this.activeDescendant =
        this.$refs.results.children[this.highlightedIndex].id;
    } else {
      this.search = this.initialValue;
      this.resetHighlightedIndex();
    }
  },
  highlightNext() {
    if (this.highlightedIndex < this.$refs.results.children.length - 1) {
      this.highlightedIndex = this.highlightedIndex + 1;

      this.search =
        this.$refs.results.children[this.highlightedIndex].getAttribute(
          "data-result-name"
        );
      this.activeDescendant =
        this.$refs.results.children[this.highlightedIndex].id;
    }
  },
  getSuggestions() {
    if (this.highlightedIndex >= 0) {
      this.resetHighlightedIndex();
    }
    // Initial value keeps the state of what the user typed before going through the menu options using arrow keys
    // this way we can reset the input to its initial value when pressing arrow up and there is no previous option
    this.initialValue = this.search;
    this.$wire.set("searchQuery", this.search);
  },
  async selectSuggestion(target) {
    this.search = target.getAttribute("data-result-name");
    this.closeMenu();

    await this.$nextTick();
    this.$dispatch("suggestion-selected");
  },
  resetHighlightedIndex() {
    this.highlightedIndex = -1;
    this.activeDescendant = "";
  },
  closeMenu() {
    this.open = false;
    this.resetHighlightedIndex();
  },
  setHighlightedIndex(index) {
    this.highlightedIndex = index;
    this.activeDescendant =
      this.$refs.results.children[this.highlightedIndex].id;
  },
  trigger: {
    ["@showAutocomplete.window"](e) {
      if (e.detail.id !== this.id) return;

      this.open = e.detail.show === true;
    },
  },
});
